<!-- src/App.vue -->
<template>
  <div id="app">
    <Header/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
  import Header from './layout/components/header.vue'
  import Footer from './layout/components/footer.vue'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
}
</script>
<style>
  body{
    margin: 0;
  }
</style>